// Init options for the telemetry vendor, kept free of any vendor import so the
// option shape stays plain data the tests can assert and the SDK is referenced in
// exactly one module (`client.ts`).

export type TelemetryInitOptions = {
  api_host: string;
  autocapture: boolean;
  capture_pageview: 'history_change' | false;
  capture_pageleave: boolean;
  capture_dead_clicks: boolean;
  capture_exceptions: boolean;
  disable_session_recording: boolean;
  session_recording: {
    maskAllInputs: boolean;
    maskTextSelector: string;
  };
};

/**
 * `captureEnabled` is the prod-only data gate (see capture-policy): when false
 * the SDK still initializes — feature flags must resolve on staging/localhost —
 * but every capture surface (autocapture, pageviews, dead clicks, exceptions,
 * session replay) is off.
 */
export function buildTelemetryConfig(host: string, captureEnabled: boolean): TelemetryInitOptions {
  return {
    api_host: host,
    autocapture: captureEnabled,
    capture_pageview: captureEnabled ? 'history_change' : false, // SPA route-change pageviews
    capture_pageleave: captureEnabled,
    capture_dead_clicks: captureEnabled, // clicks that visibly did nothing — friction signal
    capture_exceptions: captureEnabled, // unhandled errors + rejections → error tracking
    disable_session_recording: !captureEnabled,
    session_recording: {
      // Financial app: recordings must never expose balances or what the user
      // typed. Inputs are masked wholesale; ALL text is masked (replays show
      // layout/clicks/navigation). Tagging only money elements was rejected:
      // one missed tag leaks a balance.
      maskAllInputs: true,
      maskTextSelector: '*',
    },
  };
}
